import React from "react";

const ChillerTruckColdChain = ({ title, items, image, imageAlt }) => {
  return (
    <section className="ct-coldchain-section">
      <div className="container">
        <div className="row g-5">

          {/* Image — left */}
          <div
            className="col-md-6 d-flex"
            data-aos="fade-right"
            data-aos-duration="900"
            data-aos-once="true"
          >
            <img
              src={image}
              alt={imageAlt}
              className="ct-coldchain-img"
            />
          </div>

          {/* Content — right */}
          <div
            className="col-md-6"
            data-aos="fade-left"
            data-aos-duration="900"
            data-aos-once="true"
          >
            <h2 className="mb-3">{title}</h2>

            {items.map((item, i) => (
              <p key={i} className="ct-coldchain-para">
                <strong>{item.title}</strong> {item.description}
              </p>
            ))}

            <div className="d-flex gap-3 mt-4 flex-wrap">
              <a href="tel:+971544792905" className="mini-btn primary">Call for a Quote</a>
              <a
                href="https://wa.me/971544792905"
                target="_blank"
                rel="noopener noreferrer"
                className="mini-btn secondary-dark"
              >
                WhatsApp Now
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ChillerTruckColdChain;
